import React, { ReactNode } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import cx from 'classnames';

import s from './HorizontalLeftImageContent.module.scss';

interface IProps {
  imageUrl?: string;
  imageAlt?: string;
  className?: string;
  withPadding?: boolean;
  squaredImage?: boolean;
  style?: any;
  bottomContent?: ReactNode;
}
const HorizontalLeftImageContent: React.FC<IProps> = ({
  imageUrl,
  imageAlt,
  className,
  withPadding,
  squaredImage,
  children,
  bottomContent,
  ...props
}) => {
  return (
    <Card
      className={cx(s['horizontal-left-image'], 'overflow-hidden', className, {
        [s['-with-padding']]: withPadding,
        [s['-squared-image']]: withPadding,
        'donate-now-card-mobile': squaredImage,
      })}
      {...props}
    >
      <Card.Body className="p-0">
        <Row className="m-0">
          {imageUrl && (
            <Col
              sm={!squaredImage ? 12 : undefined}
              lg={!squaredImage ? 6 : undefined}
              className={cx(s['horizontal-left-image-wrapper'], {
                'py-2 pl-2 pr-0': squaredImage,
              })}
            >
              <img
                loading="lazy"
                src={imageUrl}
                alt={imageAlt}
                className="w-100"
              />
            </Col>
          )}
          <Col
            sm={!squaredImage ? 12 : undefined}
            lg={!squaredImage ? 6 : undefined}
            className={cx(
              'h-100',
              { 'px-2 py-2': squaredImage },
              s['horizontal-left-content-wrapper'],
            )}
          >
            {children}
          </Col>
        </Row>
        <Row className="m-0 pl-2 pr-2">{bottomContent}</Row>
      </Card.Body>
    </Card>
  );
};

export default HorizontalLeftImageContent;
